module.exports = __webpack_public_path__ + "img/i_pink.7544c032.svg";